var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qn-status-tag",class:_vm.color!=='cmain'?'qn-status-tag-'+_vm.color:''},[_c('div',{staticClass:"qn-triangle",class:_vm.color!=='cmain'?'qn-triangle-'+_vm.color:''}),_c('div',{staticClass:"qn-rectangle pl20 pr8",class:_vm.color!=='cmain'?'qn-rectangle-'+_vm.color:''},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }